import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { reduxForm, getFormValues, destroy } from "redux-form";
import { push } from 'connected-react-router';

import { CONCEPT_NAME } from "forms/list";
import { useModalStack } from 'utils/common';

import ConceptNamePane from "./ConceptNamePane";
import SelectCreativeTypePane from './SelectCreativeTypePane';
import DisplayConceptBreadCrumb from 'widgets/modals/DisplayConceptBreadcrumb';


import './CreateDisplayConceptModal.css';

const formValueSelector = getFormValues(CONCEPT_NAME);
const STEP_CONTENT = [
	{
		name: "Concept Name",
		Modal: ConceptNamePane,
	}, {
		name:  "Add Creative",
		Modal: SelectCreativeTypePane,
	}
];

const stepNames = STEP_CONTENT.map(step => step.name);

export default function CreateDisplayConceptModal(props){
	const dispatch = useDispatch()
		, [currentStep, setCurrentStep] = useState(0)
		, [creative, setCreative] = useState({ selected: false, type: '' })
		, { returnPath, asyncValidating, libraryId } = props
		, { Modal: StepModal } = STEP_CONTENT[currentStep]
		, values = useSelector(formValueSelector)
		, existingCreatives = useSelector(state => ({ existingCreatives: state.selected.existingCreatives }))
		, modalName = STEP_CONTENT[currentStep].name
		, headerProps = {
			className:"open-concept-header",
		};

	useEffect(() => {
		return () => {
			dispatch(destroy(CONCEPT_NAME));
		};
	}, []);

	const Breadcrumb = (
		<DisplayConceptBreadCrumb stepNames={stepNames} currentStep={currentStep} numSelected={handleSizeSelected(values)} />
	);

	function closeModal(){
		dispatch(push(returnPath));
	}

	function stepBack(){
		setCurrentStep(currentStep - 1);
	}

	function stepForward(){
		setCurrentStep(currentStep + 1);
	}

	function handleSizeSelected() {
		let baseSizes = 0
			, customSizes = 0;
		for(let key in values){
			if(key === 'base-sizes') {
				Object.values(values[key]).flat()
					//baseSizes needs to be outsize of loop
					// eslint-disable-next-line no-loop-func
					.map((size) => {
						if(size === true) {
							baseSizes += 1;
						}
					});
			}
			if(key === 'custom-sizes') {
				customSizes = values[key]?.length;
			}
		}
		return baseSizes + customSizes + existingCreatives.existingCreatives.length;
	}

	function renderTitle(){
		if(modalName === "Concept Name") {
			return "Open Display Concept";
		} else {
			return `Open Display Concept - ${values?.conceptName}`;
		}
	}

	const commonModalProps = {
		title: renderTitle(),
		type: "modal",
		allowFullScreen: false,
		className: "open-concept white-title-bar",
		bladeProps: {
			verticallyCenter: true,
		},
		headerProps,
		xClose: true,
		onClose: closeModal,
		handleSizeSelected,
		adSizes,
		values,
		asyncValidating,
		libraryId,
		returnPath,
		creative,
		setCreative,
	};

	const [modalStack, { pushModal, popModal }] = useModalStack({ commonModalProps })
		, stackLength = modalStack.length
		, CurrentModal = stackLength ? modalStack[stackLength - 1] : StepModal;

	const navigationActions = {
		closeModal,
		stepBack,
		stepForward,
		pushModal,
		popModal,
	};

	return (
		<CurrentModal
			className={STEP_CONTENT?.className}
			commonModalProps={commonModalProps}
			Breadcrumb={Breadcrumb}
			navigationActions={navigationActions}
			formName={CONCEPT_NAME}
		/>
	);
}

export const adSizes = ['300x250', '160x600', '728x90', '300x600', '320x50'];

function createInitialValues(){
	let adSizesObjs = [];
	adSizes.map((size) => {
		const split = size.split('x');
		 adSizesObjs.push({ width: split[0], height: split[1] });
	});

	let initialValues = {};
	adSizesObjs.map((sizes) => {
		const { width, height } = sizes;
		Object.assign(initialValues, { [`${width}x${height}`]: false });
	});
	return initialValues;
}

const formWrapper = reduxForm({
	form: CONCEPT_NAME,
	destroyOnUnmount: true,
	forceUnregisterOnUnmount: true,
	initialValues: createInitialValues(),
});
export const Fw = formWrapper;
